import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type CreateSearchSliceOptions = {
  prefix: string;
};

function createSearchSlice({ prefix }: CreateSearchSliceOptions) {
  return createSlice({
    name: `${prefix}/search` as string,
    initialState: {
      query: '',
    },
    reducers: {
      setSearchQuery: (state, action: PayloadAction<string>) => {
        state.query = action.payload;
      },
    },
    selectors: {
      selectSearchQuery: (state) => state.query,
    },
  });
}

export type TSearchSlice = ReturnType<typeof createSearchSlice>;
export default createSearchSlice;
